import { IconeFacebook } from '@/components/atoms/Icones/IconeFacebook';
import { IconeInstagram } from '@/components/atoms/Icones/IconeInstagram';
import { IconeSpotify } from '@/components/atoms/Icones/IconeSpotify';
import { IconeX } from '@/components/atoms/Icones/IconeX';
import { registrarEvento } from '@/services/googleAnalytics';
import { theme } from '@/styles/theme';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import google_play from '@/assets/googleplay.svg';
import appstore from '@/assets/appstore.svg';
import Text from '@/components/atoms/Text';
import useBreakpoint from '@/hooks/useBreakpoint';

export default function useFooterCorpoHook() {
  const { breakpoint } = useBreakpoint();
  const [webView, setWebView] = useState(false);

  useEffect(() => {
    const usuarioWebView = localStorage.getItem('chippuPlace@AcessoAPPChippu');
    if (usuarioWebView) {
      setWebView(true);
    }
  }, []);

  const linksChippu = [
    {
      href: '/',
      texto: 'Loja',
      eventoAnalytics: 'footer_clicou_loja',
    },
    {
      href: '/recomendados',
      texto: 'Recomendados',
      eventoAnalytics: 'footer_clicou_recomendados',
    },
    // {
    //   href: '/noticias',
    //   texto: 'Noticias',
    //   eventoAnalytics: 'footer_clicou_noticias',
    // },
    // {
    //   href: '/stramings',
    //   texto: 'Streamings',
    //   eventoAnalytics: 'footer_clicou_streamings',
    // },
    // {
    //   href: '/cinema',
    //   texto: 'Cinema',
    //   eventoAnalytics: 'footer_clicou_cinema',
    // },
  ];

  const linksServicos = [
    {
      href: `/minha-conta${breakpoint === 'desktop' ? '/meu-perfil' : ''}`,
      texto: 'Minha conta',
      eventoAnalytics: 'footer_clicou_minha_conta',
    },
    {
      href: '/ajuda',
      texto: 'Central de ajuda',
      eventoAnalytics: 'footer_clicou_central_de_ajuda',
    },
    {
      href: '/termos?tipoTermo=termosDeServico',
      texto: 'Termos de uso',
      eventoAnalytics: 'footer_clicou_termos_e_condicoes',
    },
    {
      href: '/termos?tipoTermo=politicaPrivacidade',
      texto: 'Politica de privacidade',
      eventoAnalytics: 'footer_clicou_politica_de_privacidade',
    },
    {
      href: '/minha-conta/minhas-compras',
      texto: 'Minhas compras',
      eventoAnalytics: 'footer_clicou_minhas_compras',
    },
    {
      href: '/',
      texto: 'Planos',
      eventoAnalytics: 'footer_clicou_planos',
    },
  ];

  const RedesSociais = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: theme.spacing[3],
        }}
      >
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.instagram.com/chippuoficial/"
        >
          <IconeInstagram
            size={theme.spacing[5]}
            color={theme.colors.accent.accent[9]}
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/chippuoficial"
        >
          <IconeFacebook
            size={theme.spacing[5]}
            color={theme.colors.accent.accent[9]}
            colorLogo={theme.colors.accent.accent[3]}
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://twitter.com/chippuoficial"
        >
          <IconeX
            size={theme.spacing[5]}
            color={theme.colors.accent.accent[9]}
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://open.spotify.com/show/4wu7HBfCJZqdxTc1l5kkRj?si=2dn3Q9bdQjeTomsskTD9VQ"
        >
          <IconeSpotify
            size={theme.spacing[5]}
            color={theme.colors.accent.accent[9]}
          />
        </a>
      </div>
    );
  };

  const LojasAplicativos = ({
    orientacao = 'horizontal',
  }: {
    orientacao?: 'horizontal' | 'vertical';
  }) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: orientacao === 'horizontal' ? 'row' : 'column',
          gap: theme.spacing[4],
        }}
      >
        <a
          href="https://play.google.com/store/apps/details?id=br.com.chippu.app"
          onClick={() => registrarEvento('clicou_baixar_google_play', {})}
        >
          <Image
            src={google_play}
            alt="Google Play"
            width={theme.typography.font.size[7] * 4}
            priority
          />
        </a>
        <a
          href="https://apps.apple.com/br/app/chippu/id1513274320"
          onClick={() => registrarEvento('clicou_baixar_app_store', {})}
        >
          <Image
            src={appstore}
            alt="App Store"
            width={theme.typography.font.size[7] * 4}
            priority
          />
        </a>
      </div>
    );
  };

  const FaleConosco = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing[4],
        }}
      >
        <Text
          $size={2}
          $color="neutral"
          $weight="regular"
          $align="left"
          $highContrast={true}
          $text="Tem alguma sugestão de pauta, eventos ou deseja apenas fazer uma crítica ou sugestão, manda um email pra gente."
        />
        <Text
          $size={2}
          $color="neutral"
          $weight="regular"
          $align="left"
          $highContrast={true}
          $text="contato@chippu.com.br"
          $underline={true}
        />
      </div>
    );
  };

  return {
    webView,
    linksServicos,
    linksChippu,
    RedesSociais,
    LojasAplicativos,
    FaleConosco,
  };
}
